import React from 'react';
import I18n from 'i18n-js';

import SanitizedRender from './sanitized_render';
import AffirmLearnMoreModal from './affirm_learn_more_modal';

interface IProps {
  availableTermMonths?: (number | null)[] | null;
  buyerPrice: string;
  estimatedMonthlyPayment?: string;
  maxTermMonth: number;
  zeroPercentFinancing?: boolean;
  lowestAprAtMaxTerm?: number;
  splitPay?: boolean;
}

function AffirmEstimateSmall({
  availableTermMonths,
  buyerPrice,
  estimatedMonthlyPayment,
  maxTermMonth,
  zeroPercentFinancing,
  lowestAprAtMaxTerm,
  splitPay,
}: IProps) {
  if (!estimatedMonthlyPayment || !buyerPrice || !maxTermMonth) { return null; }

  return (
    <div className="affirm-estimate-small">
      <AffirmLearnMoreModal
        estimatedMonthlyPayment={estimatedMonthlyPayment}
        buyerPrice={buyerPrice}
        maxTermMonth={maxTermMonth}
        availableTermMonths={availableTermMonths}
        zeroPercentFinancing={zeroPercentFinancing}
        lowestAprAtMaxTerm={lowestAprAtMaxTerm}
        buttonLabel={
          splitPay ? (
            <SanitizedRender
              className="affirm-estimate-small__copy"
              html={
                I18n.t('commons.affirmEstimateSmall.splitPay', {
                  price: estimatedMonthlyPayment,
                  tagOpen: '<strong>',
                  tagClose: '</strong>',
                })
              }
            />
          ) : (
            <SanitizedRender
              className="affirm-estimate-small__copy"
              html={
                I18n.t('commons.affirmEstimateSmall.asLowAs', {
                  price: estimatedMonthlyPayment,
                  tagOpen: '<strong>',
                  tagClose: '</strong>',
                })
              }
            />
          )
        }
        splitPay={splitPay}
      />
    </div>
  );
}

export default AffirmEstimateSmall;
